//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteNN from './expedienteNotasN'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteNN />
            </div>
        );
    }

}
export default Index;